import SecurityPanel from './SecurityPanel';

export default SecurityPanel;
